import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {en} from '@/locales/en';
import {ptBr} from '@/locales/pt-br';
import {i18nState} from '@/utils/store-acessor';

Vue.use(VueI18n);

const messages = {
    en,
    ptBr,
};

export const i18n = new VueI18n({
    locale: i18nState.locale.value,
    messages,
    warnHtmlInMessage: 'off',
});
